// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1CvdV","row":"Node_row__1NSrQ","label":"Node_label__XcGk3","footer":"Node_footer__26nUx"};